import React, { ComponentProps } from 'react'
import classNames from 'classnames'

import './Grid.css'

export type GridProps = {
  children: React.ReactNode
  gap?: number
  columns?: string
  style?: React.CSSProperties
} & ComponentProps<'div'>

export function Grid({ children, gap = 16, columns, ...props }: GridProps) {
  const gridStyle = {
    ...props.style,
    '--grid-gap': `${gap}px`,
    '--grid-columns': columns,
  } as React.CSSProperties

  return (
    <div className={classNames('grid', props.className)} style={gridStyle}>
      {children}
    </div>
  )
}
